import type { ComponentType } from 'react';
import type { GameId } from '../engine/games/types';
import { BaccaratTable } from './table/Baccarat';
import { BigSixTable } from './table/BigSix';
import { CasinoWarTable } from './table/CasinoWar';
import { DiceTable } from './table/Dice';
import { BlackjackTable } from './table/Blackjack';
import { CrapsTable } from './table/Craps';
import { CrashTable } from './table/Crash';
import { TableFrame, type TableProps } from './table/Frame';
import { GenericTable } from './table/Generic';
import { HighLowTable } from './table/HighLow';
import { HoldemTable } from './table/Holdem';
import { LiarsDiceTable } from './table/LiarsDice';
import { MinesTable } from './table/Mines';
import { RouletteTable } from './table/Roulette';
import { ScratchersTable } from './table/Scratchers';
import { SlotsTable } from './table/Slots';
import { ThreeCardTable } from './table/ThreeCard';
import { VideoPokerTable } from './table/VideoPoker';
import { TowerTable } from './table/Tower';
import { PlinkoTable } from './table/Plinko';
import { HorsesTable } from './table/Horses';
import { MahjongTable } from './table/Mahjong';
import { PachinkoTable } from './table/Pachinko';
import { PACHINKO } from '../webGames/pachinko';

/** Games with their own web screen. The rest use the interim text view until
 *  theirs is built (every game is slated for one). */
const SCREENS: Partial<Record<GameId, ComponentType<TableProps>>> = {
  blackjack: BlackjackTable,
  slots: SlotsTable,
  scratchers: ScratchersTable,
  crash: CrashTable,
  baccarat: BaccaratTable,
  highlow: HighLowTable,
  liarsdice: LiarsDiceTable,
  mines: MinesTable,
  roulette: RouletteTable,
  craps: CrapsTable,
  threecard: ThreeCardTable,
  holdem: HoldemTable,
  bigsix: BigSixTable,
  war: CasinoWarTable,
  dice: DiceTable,
  videopoker: VideoPokerTable,
  tower: TowerTable,
  plinko: PlinkoTable,
  horses: HorsesTable,
  mahjong: MahjongTable,
  [PACHINKO]: PachinkoTable,
};

export function Table({ snapshot, actions }: TableProps) {
  const Body = SCREENS[snapshot.activeGame!] ?? GenericTable;
  return (
    <TableFrame snapshot={snapshot} actions={actions}>
      <Body snapshot={snapshot} actions={actions} />
    </TableFrame>
  );
}
